import { Reveal } from "@/components/Reveal";

const QUOTES = [
  {
    quote: "Our guests are still talking about the espresso martini bar. Worth every cent.",
    author: "Sarah M.",
    event: "Backyard wedding",
  },
  {
    quote: "They turned our living room into the best bar in town. Zero stress, all style.",
    author: "Devon & Priya",
    event: "Engagement party",
  },
  {
    quote: "The custom menu matched our brand perfectly. Booking them again next quarter.",
    author: "Marcus T.",
    event: "Company launch",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-[#0C0C0C] border-y border-white/10">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="mb-14">
          <p className="eyebrow mb-5">Testimonials</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#F5F5F5]">
            Word of <em className="italic text-[#D98B48]">mouth</em>.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-10 md:gap-8">
          {QUOTES.map((q, i) => (
            <Reveal key={q.author} delay={i * 0.1}>
              <figure className="border-t border-white/10 pt-8 h-full flex flex-col" data-testid={`testimonial-${i + 1}`}>
                <span className="font-display text-5xl text-[#D98B48] leading-none" aria-hidden="true">&ldquo;</span>
                <blockquote className="mt-3 font-display italic text-xl md:text-2xl leading-snug text-[#F5F5F5] flex-1">
                  {q.quote}
                </blockquote>
                <figcaption className="mt-6 text-xs uppercase tracking-[0.22em] text-[#A3A3A3]">
                  — {q.author} · {q.event}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
